'use client';

import { ChatCircle } from '@phosphor-icons/react';
import Script from 'next/script';
import React, { useState } from 'react';

import IconButton from '@/components/common/IconButton';

const BASE_URL = 'https://crm.rizerssoft.app';

export default function ChatwootWidget() {
  const [loaded, setLoaded] = useState(false);

  const onScriptLoaded = () => {
    if (!loaded) {
      window.chatwootSettings = {
        style: 'flat',
        hideMessageBubble: true,
      };

      window.chatwootSDK.run({
        websiteToken: 'JpQbLx8usuZkoAhaCQNfbnGr',
        baseUrl: BASE_URL,
      });

      setLoaded(true);
    }
  };

  return (
    <>
      <Script
        src={`${BASE_URL}/packs/js/sdk.js`}
        defer
        onLoad={onScriptLoaded}
      />
      {loaded && (
        <IconButton
          icon={<ChatCircle weight="fill" />}
          className="circle-button-shinny button-ping !size-12 rounded-full !p-0 transition-all duration-500"
          type="button"
          onClick={() => window.$chatwoot.toggle()}
          aria-label="Chat with support"
        />
      )}
    </>
  );
}
